import(/* webpackMode: "eager" */ "/builds/my-team/writemail.ai-signature-generator/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/builds/my-team/writemail.ai-signature-generator/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/builds/my-team/writemail.ai-signature-generator/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/builds/my-team/writemail.ai-signature-generator/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/my-team/writemail.ai-signature-generator/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
